<h1 mat-dialog-title>{{head}}</h1>
<div mat-dialog-content>
  {{ask}}
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="close(false)">No</button>
  <button mat-button mat-dialog-close cdkFocusInitial (click)="close(true)">Yes</button>
</div>
